<template>
  <li class="h-24">
    <router-link
      :to="route"
      class="flex flex-col h-full p-2 items-center justify-center text-xs text-center text-white uppercase transition-colors duration-200"
      :class="[isCitizenM ? 'hover:bg-citizenM-900': 'hover:bg-blue-400', isCurrentRoute ? isCitizenM ? 'bg-citizenM-900': 'bg-blue-400' : '', {'opacity-50 cursor-not-allowed': disabled}]"
    >
      <img :src="`/img/navigation/${icon}.png`" class="mb-2" :alt="title" />
      <span>{{ title }}</span>
    </router-link>
  </li>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { CUSTOMER_IDS } from '@/constants'

export default {
  name: 'NavItem',
  props: {
    route: {
      type: [Object, String], // use '#" for disabled links
      required: true
    },
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    disabled: Boolean
  },
  setup (props) {
    const currentRoute = useRoute()
    const router = useRouter()
    const store = useStore()

    const customerID = computed(() => store.getters['customers/customer'].ID)
    const isCitizenM = computed(() => customerID.value === CUSTOMER_IDS.CITIZENM)
    const isCurrentRoute = computed(() => currentRoute.fullPath === router.resolve(props.route).href)

    return {
      isCitizenM,
      isCurrentRoute
    }
  }
}
</script>
